<template>
  <ModalDialog
    ref="dialog"
    :title="`Update ${isShipping ? 'Shipping' : 'Receiving'} Date Advised`"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-calendar-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow :label="`${isShipping ? 'Shipping' : 'Receiving'} Date Advised`">
        <FormDate v-model="advisedInfo.dateAdvised" field="dateAdvised" />
      </FormRow>
      <FormRow label="Advised Note">
        <FormInputText v-model="advisedInfo.note" field="note" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'DateAdvisedDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    isShipping: Boolean,
    purchaseOrderId: Number,
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      advisedInfo: {},
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.advisedInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      if(this.isShipping) {
        this.$apiService.purchasingService.updateAdvisedShippingPurchaseOrder(this.purchaseOrderId, this.advisedInfo)
        .then(response => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      } else {
        this.$apiService.purchasingService.updateAdvisedReceivingPurchaseOrder(this.purchaseOrderId, this.advisedInfo)
        .then(response => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.$data.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.$data.submitting = false
        })
      }
    }
  }
}
</script>